import React from "react";
import { formatPresenceStatus } from "../lib/formatPresence";

/**
 * Shared presence presentation — Online / neutral last-seen / nothing.
 * Presentation-only: accepts already-selected presence row.
 */
export default function PresenceStatusText({
  presence,
  className = "",
  onlineClassName = "",
  offlineClassName = "",
}) {
  const status = formatPresenceStatus(presence);
  if (status.kind === "none" || !status.text) {
    return null;
  }
  const extra = status.kind === "online" ? onlineClassName : offlineClassName;
  return (
    <span
      className={["presence-status-text", className, extra].filter(Boolean).join(" ")}
      data-presence-kind={status.kind}
    >
      {status.text}
    </span>
  );
}
